export class Location {
  id: string;
  responsibleAgencyFormat: string;
  constructor() {
  }
}
